import MightLikeFailure from "./MightLikeFailure";
import { UNAMUSED } from "../faceEmoji";
import { useRuntimeConstants } from "../../context/runtimeConstants/RuntimeConstantsContext";

const MightLikeNoItems = ({ additionalClasses }) => {
  const { getTranslation } = useRuntimeConstants();

  return (
    <MightLikeFailure
      titleTranslationKey="similar_items_no_results_title"
      subTitleTranslationKey="similar_items_no_results_subtitle"
      emojiType={UNAMUSED}
      ariaLabel={getTranslation("emoji_face_unamused")}
      additionalClasses={additionalClasses}
    />
  );
};
export default MightLikeNoItems;
